
import { INVALIDATE_DOSSIER, INVALIDATE_FOURNISSEURS, INVALIDATE_CLIENT, INVALIDATE_DOSSIER_PARTAGE, INVALIDATE_FACTURES } from 'actions/invalidationTags';
import { ApiMananger } from "actions/rtkquery";
import { ADD_CLIENT_API_ROUTE, ADD_DOSSIER_CLIENT_API_ROUTE, ADD_FOURNISSEUR_API_ROUTE, DELETE_DOSSIER_CLIENT_API_ROUTE, UPDATE_DOSSIER_CLIENT_API_ROUTE } from "routes/api/endpoints";

const dossierApi = ApiMananger.injectEndpoints({
    endpoints: (build) => ({

        // DOSSIER CLIENT
        createDossier: build.mutation({
            query(body) {
                return {
                    url: ADD_DOSSIER_CLIENT_API_ROUTE,
                    method: "POST",
                    body,
                };
            },
            invalidatesTags: [INVALIDATE_DOSSIER, INVALIDATE_FOURNISSEURS],
        }),
        updateDossier: build.mutation({
           
            query({id, body, token}) {
                // console.log(id)
                return {
                    url: `${UPDATE_DOSSIER_CLIENT_API_ROUTE}${id}/`,
                    method: "PUT",
                    body,
                       headers: {
                        Authorization: `Bearer ${token}`,
                      },
                };
            },
            invalidatesTags: [INVALIDATE_DOSSIER],
        }),
        updateDossierClient: build.mutation({
           
            query({id, body, token}) {
                // console.log(id)
                return {
                    url: `${UPDATE_DOSSIER_CLIENT_API_ROUTE}${id}/`,
                    method: "PUT",
                    body,
                       headers: {
                        Authorization: `Bearer ${token}`,
                      },
                };
            },
            invalidatesTags: [INVALIDATE_DOSSIER, INVALIDATE_FACTURES],
        }),
        deleteDossier: build.mutation({
            query: ({ id, token }) => {
                return {
                    url: `${DELETE_DOSSIER_CLIENT_API_ROUTE}${id}/`,
                    method: "DELETE",
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                };
            },
            invalidatesTags: [INVALIDATE_DOSSIER],
        }),
        

        // CLIENT
        createClient: build.mutation({
            query(body) {
                return {
                    url: ADD_CLIENT_API_ROUTE,
                    method: "POST",
                    body,
                };
            },
            invalidatesTags: [INVALIDATE_CLIENT],
        }),

        // FOURNISSEUR
        createFournisseur: build.mutation({
            query(body) {
                return {
                    url: ADD_FOURNISSEUR_API_ROUTE,
                    method: "POST",
                    body,
                };
            },
            invalidatesTags: [INVALIDATE_FOURNISSEURS],
        }),

        //Get dossier client
        addDossierPartage: build.mutation({
            query: ({ dossier_id, body }) => ({
                url: `v1/dossiers-client/${dossier_id}/partage/`,
                method: "POST",
                body,
            }),
            invalidatesTags: [INVALIDATE_DOSSIER_PARTAGE],
        }),
        deleteDossierPartage: build.mutation({
            query: ({ dossier_id, access_id }) => ({
                url: `v1/dossiers-client/${dossier_id}/partage/${access_id}/`,
                method: "DELETE",
            }),
            invalidatesTags: [INVALIDATE_DOSSIER_PARTAGE],
        }),
        updateDossierPartage: build.mutation({
            query: ({ dossier_id, access_id, body }) => ({
                url: `v1/dossiers-client/${dossier_id}/partage/${access_id}/`,
                method: "PUT",
                body,
            }),
            invalidatesTags: [INVALIDATE_DOSSIER_PARTAGE],
        }),

    }),
});

export const {
    //dossier
    useCreateDossierMutation,
    useUpdateDossierMutation,
    useUpdateDossierClientMutation,
    useDeleteDossierMutation,
    //CLIENT
    useCreateClientMutation,
    //FOURNISSEUR
    useCreateFournisseurMutation,
    useAddDossierPartageMutation,
    useDeleteDossierPartageMutation,
    useUpdateDossierPartageMutation,
} = dossierApi;